<template>
    <div class="wxLogin_container" style="text-align:center;">
        <!-- <el-select @change="changeOrg" style="width:100%" v-model="deptId" filterable remote reserve-keyword placeholder="机构/图书馆" :filter-method='loginInfo'>
            <template slot="prefix">
                <span style="padding: 5px;font-size: 18px;vertical-align: -12px;color: #C0C4CC;">
                    <i class="el-icon-school"></i>
                </span>
            </template>
            <el-option v-for="item in info" :key="item.pkid" :label="item.orgName" :value="item.pkid"></el-option>
        </el-select>  -->
        <el-empty v-if="!codeUrl" description="请选择图书馆机构获取二维码！"></el-empty>
        <div class="code_box" v-else id="codebox">
            <div class="status_dialog" v-if="loginStatus">
                <el-result v-if="loginStatus=='-5'" icon="error" title="二维码已过期！请重试...">
                    <template slot="extra">
                        <el-button type="primary" size="mini" icon="el-icon-refresh" @click="changeOrg(deptId)">刷新</el-button>
                    </template>
                </el-result>
                <!-- {{ loginStatus == 1 ? '扫码成功！' : (loginStatus == 2 ? '正在确认登录！' : '登录成功！') }} -->
                <el-result v-else icon="success" :title="loginStatus == 1 ? '扫码成功！' : (loginStatus == 2 ? '正在登录...' : '登录成功！')"></el-result>
            </div>
            <canvas ref="qrCanvas" style="width:220px;height:220px;"></canvas>
        </div>
        <el-button type="primary" plain size="mini" @click="closeDialog">关闭</el-button>
    </div>
</template>

<script>
import Axios from 'axios';
import QRCode from 'qrcode'
import { env } from '../../dataJson/custom.js'
import MD5 from "../../common/utils/MD.js"
import { loginInfo } from "@/api/login"
import {  generator } from "@/api/colinfo"
import { setItem, getUserInfo } from "@/common/utils/localStorage.js";
export default {
    props:['orgid'],
    data(){
        return {
            deptId: null,
            info:[],
            codeUrl:null,
            loadingInstance: null,
            loginStatus: null,
            wxTimer:null,
            countdown:0,
        }
    },
    mounted(){
        let vm = this;
        vm.deptId = vm.orgid;
        vm.changeOrg();
    },
    methods:{
        closeDialog(){
            let vm = this;
            clearInterval(vm.wxTimer);
            vm.wxTimer = null;
            vm.$emit('close');
        },
        loginInfo(query) {
            let vm = this,
            obj = {
                orgStatus: 1,
                deviceType: 1,
                orgName: query,
                orgType: 1,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            };
            if(query) {
                loginInfo(obj).then((res) => {
                    vm.info = res.data.list
                }); 
            }
        },
        //选择机构获取二维码链接
        changeOrg(){
            let vm = this,
                loading = this.$loading({
                    text: "生成中...", // 设置 loading 文本为 "加载中"
                    spinner: "el-icon-loading", // 使用 Element UI 提供的加载图标
                    background: "rgba(255, 255, 255, 0.7)", // 设置 loading 遮罩层背景色为半透明黑色
                    target: document.querySelector('.codebox'), // 将 loading 遮罩层挂载到页面 body 元素上
                });
            
            clearInterval(vm.wxTimer);
            vm.wxTimer = null;
            // Axios.get('/auth/ttv3/security/core/wxqrcode/unique/code',{
            Axios.get(env+'/ttv3/security/core/wxqrcode/unique/code',{
                params: {
                    orgId: vm.deptId,
                    deviceType:1,
                }
            }).then(res => {
                let data = res.data.split('&');
                vm.codeUrl = 'http://read.book05.com'+env+'/ttv3/security/core/wxqrcode/login?sessionId='+data[0]+'&timeStamp='+data[1];
                // vm.codeUrl = 'http://192.168.7.7:1234/ttv3/security/core/wxqrcode/login?sessionId='+data[0]+'&timeStamp='+data[1];
                vm.$nextTick(() => {
                    vm.generateQRCode(data[0]); 
                    loading.close();  
                });
            }).catch(err => {
                loading.close();
            });
        },
        //获取二维码
        generateQRCode(sessionId) {
            let vm = this;
            const canvas = vm.$refs.qrCanvas;
            QRCode.toCanvas(canvas, vm.codeUrl, error => {
                if(error) {
                    
                } else {
                     // 生成二维码成功
                    console.log('生成二维码成功！');
                    vm.countdown = 40;  //设定40s二维码过期
                    vm.wxTimer = setInterval(() => {
                        vm.countdown--;
                        if (vm.countdown == 0) {
                            clearInterval(vm.wxTimer);
                            vm.wxTimer = null;
                            vm.loginStatus = '-5';//过期
                        }else{
                            vm.getWxLoginStatus(sessionId);
                        }
                    }, 1000);
                }
            });
        },
        //获取扫码状态
        getWxLoginStatus(sessionId){
            let vm = this;
            // Axios.get('/auth/ttv3/security/core/wxqrcode/login/state', {
            Axios.get(env+'/ttv3/security/core/wxqrcode/login/state', {
                params: {
                    sessionId: sessionId
                }
            }).then(res => {
                if(res.status){
                    vm.loginStatus = res.data;
                    if(res.data == 3){
                        clearInterval(vm.wxTimer);
                        vm.wxTimer = null;
                        vm.wxScanSuccess(sessionId);
                    }
                }
            }).catch(err => {
                
            });
        },
        //扫码登录成功后，获取用户信息,存到本地
        wxScanSuccess(sessionId){
            let vm = this;
            // Axios.get('/auth/ttv3/security/core/wxqrcode/login/sucinfo',{
            Axios.get(env+'/ttv3/security/core/wxqrcode/login/sucinfo',{
                params: {
                    sessionId: sessionId
                }
            }).then(result => {
                let resData = result.data;
                if(resData.status){
                    // setItem("token", sessionId);
                    vm.$emit('ok', resData);
                }
            }).catch(err => {
                
            });
        },
    }   
}
</script>

<style lang="scss">
    .code_box{
        width:220px;
        height:220px;
        margin:20px auto;
        position: relative;
        .el-result{
            padding: 40px 0;
        }
        .el-result__title p{
            font-size:16px;
            font-weight: bold;
            color:#fff;
        }
        .status_dialog{
            position: absolute;
            top:0;
            left:0;
            width:220px;
            height:220px;
            z-index:9;
            background-color:rgba(0, 0, 0, 0.5);
            color:#fff;
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Login/wxCodeLogin.vue